import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { c_card_cloud_ai_stat_component } from './c_card_cloud_ai_stat.component';
import { SharedModule } from '../../../../../app/directives/shared.module'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
  ],
  declarations: [c_card_cloud_ai_stat_component],
  exports: [c_card_cloud_ai_stat_component],
})
export class c_card_cloud_ai_stat_module { }
